<template>
    <ForgetPassword></ForgetPassword>
    <Footer></Footer>
</template>

<script>
  import ForgetPassword from '@/components/user/ForgetPassword.vue'
  import Footer from '@/components/Footer.vue'

import {mapGetters,mapActions} from 'vuex'
  export default {
    components: {
        ForgetPassword,
        Footer
    },
      computed: {
        ...mapGetters([
            'isMobile'
        ]),
    },
  }
</script>

